import React from "react";
import { Image, Linking, ScrollView, Text, TouchableOpacity, useWindowDimensions, View } from "react-native";
import { ALERT_ICON, ANDROID_ICON, IOS_ICON, LOGO, WEB_ICON } from "src/resources/IMAGES";
import { styles } from "./styles";
import { BRAND_NAMES, getCompanyName } from "@lib/utilities/Constants";
import { theme } from "src/theme/theme";
import { customerCareEmail } from "src/resources/strings";
import { getConfiguredBrandName, getEnvironment } from "@lib/utilities/HelperFunctions";

const AccountDeletion = ({ navigation }) => {

  const {width, height} = useWindowDimensions()
  const companyName = getCompanyName();
  const isCore = companyName === BRAND_NAMES.CORE;
  const isPraxis = companyName === BRAND_NAMES.PRAXIS;
  const environment = getEnvironment();
  
  const webUrl = isPraxis
  ? `https://praxis.${environment}exzeo.com`
  : `https://policy.${environment}${isCore ? "coreins" : companyName.toLocaleLowerCase()}.com/login`;

  const androidUrl = process.env.REACT_APP_ANDROID_STORE_URL;
  const appStoreUrl = process.env.REACT_APP_IOS_STORE_URL;
  const brandName = companyName;
  const configuredBrandName = getConfiguredBrandName(brandName)

  const isNarrowLayout = width < 1100 || height > width;
  const isStackedButtons = width < 1200;
  const deletionSteps = [
    "Log in to the App or Website.",
    "Navigate to Profile.",
    "Select Manage Account.",
    "Select Delete Account.",
    "Confirm the deletion request.",
  ];

  const BrandLogo = () => (
    <Image 
      source={LOGO}
      style={styles.brandLogo}
    />
  )
  const Header = () => (
    <View style={styles.headerContainer}>
      <Image source={ALERT_ICON} style={styles.alertIcon} />
      <Text style={styles.headerTxt}>Account Deletion</Text>
    </View>
  )
  const PlatformBtn = ({platform}:{platform:string}) => {

    const handleBtnPress = () => {      
      if(platform=="web") {
        Linking.openURL(String(webUrl));
      } else if(platform=="android") {
        Linking.openURL(String(androidUrl));
      } else if(platform=="ios") {
        Linking.openURL(String(appStoreUrl));
      }
    }

    return(
        <TouchableOpacity  style={[styles.platformBtn,
          (platform=="android" || platform=="ios")&& styles.mobileBtn 
        ]}
        onPress={handleBtnPress}>
          <Text style={[styles.platformBtnTxt]}>{platform=="web"?"Web":platform=="android"?"Android":"iOS"}</Text>
          <Image source={platform=="web"?WEB_ICON:platform=="android"?ANDROID_ICON:IOS_ICON} style={styles.platformIconImage} />
        </TouchableOpacity>
      )
  } 
  const Content = () => {
    const handleEmailPress = () => {
      Linking.openURL(`mailto:${customerCareEmail}`)
    }
    return (
      <View style={styles.contentContainer}>
        <View style={[isNarrowLayout?[styles.col]:styles.rowCenter,{top:-60}]}>
          <View style={styles.deleteCardContainer}>
            <Text style={styles.cardTitleTxt}>Delete through the App or Website</Text>

            {deletionSteps.map((step, index) => (
              <React.Fragment key={index}>
                <Text style={styles.deleteGuidelines}>{`${index + 1}. ${step}`}</Text>
                {index < deletionSteps.length - 1 && <View style={styles.separator} />}
              </React.Fragment>
            ))}

            <View style={[styles.bottomButtonsContainer,isStackedButtons&&styles.col,{}]}>
              <Text style={styles.loginViaTxt}>Login via</Text>
              <PlatformBtn platform={"web"} />
              <View style={[styles.rowCenter, {gap:theme.spacing.reg,}]}>
                <PlatformBtn platform={"android"} />
                <PlatformBtn platform={"ios"} />
              </View>
            </View>
          </View>
          <View style={isNarrowLayout ? styles.deleteCardContainerNoFlex : styles.deleteCardContainer}>
            <Text style={styles.cardTitleTxt}>Request Deletion by Email</Text>
            <Text style={styles.deleteGuidelines}>If you're unable to access your account through the {configuredBrandName} app or website, you can request account deletion by contacting our Customer Service team.
              {"\n"}Please send the email to <TouchableOpacity onPress={handleEmailPress}><Text style={styles.hyperlink}>{customerCareEmail}</Text></TouchableOpacity> from the same email address associated with the Policy.{"\n \n"}</Text>
            <Text style={styles.deleteGuidelines}>
              In your email, please include:{"\n"}<Text style={styles.highlightedText}>Full Name, Registered Email Address, Policy Number (if available) and a request to delete your account</Text>
              {"\n \n"}
            </Text>
            <Text style={styles.deleteGuidelines}>Our team may contact you if additional information is required to verify your identity before processing your request.</Text>
          </View>
        </View>
        <View style={styles.footerContainer}>
          <Text style={styles.footerHeaderTxt}>Once your request has been processed</Text>
          <Text style={styles.footerTxt}>• Your {configuredBrandName} App account will be permanently deleted. </Text>
          <Text style={styles.footerTxt}>• Your personal information associated with the account will be deleted in accordance with our data retention policies. </Text>
          <Text style={styles.footerTxt}>• Certain information may be retained where required by applicable laws, regulations, or insurance recordkeeping requirements.</Text>
        </View>
      </View>
    );
  };

  return (
    <ScrollView style={styles.container} contentContainerStyle={{flex:1}} showsVerticalScrollIndicator={false}>
      <BrandLogo />
      <Header />
      <Content />
    </ScrollView>
  );
};

export default AccountDeletion;
